import getKhattabat101MStore from "../../../../../stores/khattabat-stores/101-m-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import SelectAll from "../../shared/SelectAll";
import Actions from "./Actions";
import MessageToSend from "./MessageToSend";
import Title from "./Title";

const CreateOneOOneM = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1510}
      height={400}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Title />
      <SelectAll
        onClick={getKhattabat101MStore().toggleIsMatchesIdsSelectedAll}
        state={getKhattabat101MStore().isMatchesIdsSelectedAll.get()}
      />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <MessageToSend />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <Actions />
    </ET3Div>
  );
});

export default CreateOneOOneM;
